import { I } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatAccordion, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';
import { Idocument_DIrectmsg } from 'src/app/models/IDocument';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { SearchPatientDMPopupComponent } from 'src/app/search-patient-dmpopup/search-patient-dmpopup.component';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { CptordersService } from 'src/app/Services/NewVisitNote/cptorders.service';
import { PatientformService } from 'src/app/Services/PatientForms/patientform.service';
import { CCDAService } from '../ccda.service';
import { ReviewandFinalizeComponent } from './reviewand-finalize/reviewand-finalize.component';
declare var $: any;
@Component({
  selector: 'app-import-cda-xml',
  templateUrl: './import-cda-xml.component.html',
  styleUrls: ['./import-cda-xml.component.css']
})
export class ImportCdaXMLComponent implements OnInit {
  @ViewChild(MatAccordion, { static: false }) accordion: MatAccordion;
  step = 0;
  importCdaXmlForm: FormGroup;
  XMLFileString: any = null;
  CDAHumanReadableFormat: string = ''
  PatientId: string = '';
  ReconsoladatedPatientInfo: any = null;
  Reconsole_Problems: any = [];
  Reconsole_Allergy: any = [];
  Reconsole_Medications: any = [];
  PatientVisitDetails: any = [];
  PatientVisitDetailsMain: any = [];
  PatientPersonalInfo: any;
  IsExternalFile: boolean = false;
  ImportCCDAID: any;
  problemICDFilter: Observable<string[]>;
  ValidationMessageJson: any;
  directMessageId: any
  btnBacktext: string;
  LoginUserName: string;
  LocationName: string;
  CurrentDate: Date;
  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    private _ccdaService: CCDAService,
    private _PatientformService: PatientformService,
    private toastr: ToastrService,
    private _datePipe: DatePipe,
    private docService: DocumentService,
    private cptservice: CptordersService,
    private bannerService: PatientBannerService
    , private spinner: NgxSpinnerService
    , private router: Router, private fb: FormBuilder,
  ) {
    this.PatientId = sessionStorage.getItem("patientId");
    // if (data) {
    //   this.PatientId = this.data.patientid;

    // }
    this.docService.getAllDocCategory(0, Number(sessionStorage.getItem("FacilityId")), 1).subscribe(data => {
      var doc = data.filter(i => i.documentCategory == 'Import CCDA');
      if (doc) {
        this.ImportCCDAID = doc[0];
        this.docService.getAllSubCategoryByCategoryID(this.ImportCCDAID.docCategoryId).subscribe((res: any) => {
          this.ImportCCDAID.subCategoryId = res[0].subCategoryId;
          this.ImportCCDAID.subCategoryName = res[0].subCategoryName;
        })

      }
    });



  }
  fnFormatDate(datestr: string): string {
    if (datestr && datestr.length >= 8 && datestr.indexOf('/') == -1)
      return datestr.slice(4, 6) + '/' + datestr.slice(6, 8) + '/' + datestr.slice(0, 4)
    return "";
  }
  ngOnInit() {
    this.importCdaXmlForm = this.fb.group({
      MedicationCheckbox: [''],
      ProblemsChecked: [''],
    });
    this.IsExternalFile = false;
    this._PatientformService.getPersonalInfo(Number(this.PatientId)).subscribe(res => {
      this.PatientPersonalInfo = res;
    })
    // this.spinner.show();


    if (sessionStorage.getItem("XMLFileString")) {
      this.XMLFileString = sessionStorage.getItem("XMLFileString");
      this.ValidationMessageJson = JSON.parse(sessionStorage.getItem("ValidationMessageJson"));
      this.directMessageId = sessionStorage.getItem("DirectMsgId") ? sessionStorage.getItem("DirectMsgId") : '';
      sessionStorage.removeItem("XMLFileString");
      sessionStorage.removeItem("ValidationMessageJson");
      sessionStorage.removeItem("DirectMsgId");
      this.IsExternalFile = true;
      //this.fnReconsileCCDA();
      this.spinner.show();
      forkJoin(this._ccdaService.PatientActiveData_Reconsolation(this.PatientId),
        this._ccdaService.GetdatafromCCDA(this.XMLFileString)
      ).subscribe(([Reconsilation, xmlFileData]: any) => {

        this.PatientVisitDetails = this.PatientVisitDetailsMain = Reconsilation;
        this.ReconsoladatedPatientInfo = xmlFileData;
        this.ReconsoladatedPatientInfo.problemList.map(x => x.isChecked = false);
        this.ReconsoladatedPatientInfo.allErgies.map(x => x.isChecked = false);
        this.ReconsoladatedPatientInfo.medicationList.map(x => x.isChecked = false);
        this.CDAHumanReadableFormat = xmlFileData.CDAHumanReadableFormat;
        this.fnDisableChekboxesIfExists();
        this.spinner.hide();
      }, (err) => { this.spinner.hide(); })
    }
    else
      this.fnPatientActiveData_Reconsolation();

    this.btnBacktext = this.directMessageId != '' ? 'Back to Messages' : 'Back to Clinical Summary'
    try {
      this.CurrentDate = new Date();
      this.LoginUserName = sessionStorage.getItem("username");
      const userlocations = JSON.parse(sessionStorage.getItem("UserLocations"));
      const locationID = sessionStorage.getItem("LocationId");

      this.LocationName = userlocations.filter(i => i.locationId == locationID)[0].locationName

    } catch (e) { }


  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  problemICD: any = [];

  searchReferraldropdownValue: string = "";
  async onProblemDropdownSearch(val: any) {
    this.ClearAutoText();
    this.searchReferraldropdownValue = val;
    if (this.searchReferraldropdownValue.length >= 1) {
      await this.cptservice.GetICDCodes_AutocompleteSearch(this.searchReferraldropdownValue).subscribe(
        data => {
          this.problemICD = data;
        }
      );
    } else {
      this.problemICD = [];

    }
  }
  fnClearProblemICDCodes(problems) {
    problems.problemTypeCode = "";
    problems.problemTypeDisplayName = "";
    problems.disabled = true;
    problems.checked = false;
  }
  ClearAutoText() {
    this.problemICD = [];
  }
  fnProblemICD_Change(element, problems) {
    problems.problemTypeCode = element.icdCode;
    if (element.icdCodeDescription && element.icdCodeDescription.indexOf('(') > -1)
      problems.problemTypeDisplayName = element.icdCodeDescription.substring(0, element.icdCodeDescription.lastIndexOf("("));
    else
      problems.problemTypeDisplayName = element.icdCodeDescription;
    problems.disabled = false;
  }
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  fnDisableChekboxesIfExists() {
    if (this.ReconsoladatedPatientInfo != null) {
      this.ReconsoladatedPatientInfo.problemList.forEach(element => {
        if (this.PatientVisitDetailsMain.problems.filter((i: any) => i.Code == element.problemTypeCode || i.Code == element.snomedProblemCode).length > 0) {

          element.disabled = true;
          element.isChecked = false;
        }

        else
          element.disabled = false;
      });

      this.ReconsoladatedPatientInfo.allErgies.forEach(element => {
        if (this.PatientVisitDetailsMain.allergies.filter((i: any) => i.Code == element.drugId).length > 0) {
          element.disabled = true;
          element.isChecked = false;
        }
        else
          element.disabled = false;
      });


      this.ReconsoladatedPatientInfo.medicationList.forEach(element => {
        if (this.PatientVisitDetailsMain.medication.filter((i: any) => i.Code == element.medicationCode).length > 0) {
          element.disabled = true;
          element.isChecked = false;
        }
        else
          element.disabled = false;
      });
    }
  }
  fnPatientActiveData_Reconsolation() {
    this.spinner.show();
    this._ccdaService.PatientActiveData_Reconsolation(this.PatientId).subscribe(res => {
      this.PatientVisitDetails = this.PatientVisitDetailsMain = res;
      this.fnDisableChekboxesIfExists();
      this.spinner.hide();

      /*
            if (this.PatientVisitDetails) {
              if (this.PatientVisitDetails.problems)
                this.PatientVisitDetails.problems = this.PatientVisitDetails.problems.filter((x: any) => x.inputType == 'Md4FRONT');
              if (this.PatientVisitDetails.allergies)
                this.PatientVisitDetails.allergies = this.PatientVisitDetails.allergies.filter((x: any) => x.inputType == "MD4FRONT");
              if (this.PatientVisitDetails.medication)
                this.PatientVisitDetails.medication = this.PatientVisitDetails.medication.filter((x: any) => x.inputType == 'Md4FRONT');
            }
            */
    })
  }
  onCloseClick() {
    this.dialogRef.close();
  }
  fnclear() {
    this.IsExternalFile = false;
    this.Reconsole_Problems = [];
    this.Reconsole_Allergy = [];
    this.Reconsole_Medications = [];
    this.ReconsoladatedPatientInfo = null;
    this.XMLFileString = null;
    this.CDAHumanReadableFormat = ''

  }
  fnUploadDoc(event) {
    this.spinner.show();
    this.ValidationMessageJson = null;
    this.fnclear();

    // const filepath = "http://25.58.178.202:8080/referenceccdaservice/?validationObjective=ccda_ig_only&&referenceFileName=170.315_b1_toc_amb_sample1_v13.pdf&&curesUpdate=true&&vocabularyConfig=ccdaReferenceValidatorConfig";
    const filepath = "http://192.168.0.32:8080/referenceccdaservice/?validationObjective=ccda_ig_only&&referenceFileName=170.315_b1_toc_amb_sample1_v13.pdf&&curesUpdate=true&&vocabularyConfig=ccdaReferenceValidatorConfig";

    var fr = new FileReader();
    var self = this;
    fr.onload = function () {
      self.XMLFileString = fr.result;
      self.fnReconsileCCDA();
    }
    this._ccdaService.uploadCDAFile(filepath, event.target.files[0]).subscribe((res: any) => {
      const parsedJs = JSON.parse(res);

      this.ValidationMessageJson = {
        ccdaDocumentType: parsedJs.resultsMetaData.ccdaDocumentType,
        ccdaFileName: parsedJs.resultsMetaData.ccdaFileName,
        ccdaVersion: parsedJs.resultsMetaData.ccdaVersion,
        objectiveProvided: parsedJs.resultsMetaData.objectiveProvided,
        ResultsMetadata: parsedJs.resultsMetaData.resultMetaData,
        serviceError: parsedJs.resultsMetaData.serviceError,
        ccdaValidationResults: parsedJs.ccdaValidationResults,
        vocabularyValidationConfigurationsCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsCount,
        vocabularyValidationConfigurationsErrorCount: parsedJs.resultsMetaData.vocabularyValidationConfigurationsErrorCount,
        severityLevel: parsedJs.resultsMetaData.severityLevel,
        totalConformanceErrorChecks: parsedJs.resultsMetaData.totalConformanceErrorChecks

      }

      window.setTimeout(new function () {
        fr.readAsText(event.target.files[0]);
      }, 1000)
      this.spinner.hide();
    },
      (err) => {  this.spinner.hide(); });



  }

  fngetbytype(type: string): any {
    // if (this.ValidationMessageJson.ccdaValidationResults)
    //   return false;
    return this.ValidationMessageJson.ccdaValidationResults.filter(function (el) {
      return el.type.indexOf(type) > -1;
    });

    // return this.ValidationMessageJson.ccdaValidationResults.filter(i => i.type.indexOf('Error') > -1).length>0;
  }

  fnHasNoErrors(): boolean {
    // if (this.ValidationMessageJson.ccdaValidationResults)
    //   return false;
    return this.ValidationMessageJson.ccdaValidationResults.some(function (el) {
      return el.type.indexOf('Error') > -1;
    });

    // return this.ValidationMessageJson.ccdaValidationResults.filter(i => i.type.indexOf('Error') > -1).length>0;
  }
  fnReconsileCCDA() {
    this.spinner.show();
    this._ccdaService.GetdatafromCCDA(this.XMLFileString).subscribe(res => {
      this.ReconsoladatedPatientInfo = res;
      this.ReconsoladatedPatientInfo.problemList.map(x => x.isChecked = false);
      this.ReconsoladatedPatientInfo.allErgies.map(x => x.isChecked = false);
      this.ReconsoladatedPatientInfo.medicationList.map(x => x.isChecked = false);
      this.fnDisableChekboxesIfExists();
      this.CDAHumanReadableFormat = res.CDAHumanReadableFormat;
      this.spinner.hide();
      // this.ReconsoladatedPatientInfo.problemList.forEach(element => {
      //   if (this.PatientVisitDetailsMain.problems.filter((i: any) => i.Code == element.problemTypeCode).length > 0)
      //     element.disabled = true;
      //   else
      //     element.disabled = false;
      // });

      // this.ReconsoladatedPatientInfo.allErgies.forEach(element => {
      //   if (this.PatientVisitDetailsMain.allergies.filter((i: any) => i.Code == element.drugId).length > 0)
      //     element.disabled = true;
      //   else
      //     element.disabled = false;
      // });


      // this.ReconsoladatedPatientInfo.medicationList.forEach(element => {
      //   if (this.PatientVisitDetailsMain.medication.filter((i: any) => i.Code == element.medicationCode).length > 0)
      //     element.disabled = true;
      //   else
      //     element.disabled = false;
      // });
    }, (err) => {  this.spinner.hide(); });


  }
  fnIsProblemsChecked() {
    if (this.Reconsole_Problems.length == 0)
      return false;
    return (this.Reconsole_Problems.length == this.ReconsoladatedPatientInfo.problemList.length)

  }
  fnProblemsCheckboxClick(event) {
    const isChecked = event.target.checked;
    if (isChecked == true) {
      // this.ReconsoladatedPatientInfo.problemList.filter(i => i.disabled == false).forEach(element => {
      //   element.isChecked = true;
      //   this.Reconsole_Problems.push(element);
      // })
      this.Reconsole_Problems = [];
      if (this.ReconsoladatedPatientInfo.problemList.filter(i => i.problemTypeCode == '').length > 0) {
        alert("Map Problem in ICD");
        this.importCdaXmlForm.patchValue({
          ProblemsChecked: false
        })
        return false;
      }

      this.ReconsoladatedPatientInfo.problemList.filter(i => i.disabled == false).forEach(element => {
        if (element.problemTypeCode == '') {
          element.isChecked = false;
          //this.Reconsole_Problems.push(element);
        } else {
          element.isChecked = true;
          this.importCdaXmlForm.patchValue({
            ProblemsChecked: true
          })
          this.Reconsole_Problems.push(element);
        }
      })

    }

    else {
      this.ReconsoladatedPatientInfo.problemList.forEach(element => {
        element.isChecked = false;

      });
      this.Reconsole_Problems = [];
    }


  }


  fnSelectedProblems(element: any, event) {
    if (element.problemTypeCode == '') {
      alert("Map Problem in ICD");
      event.target.checked = false;
      element.isChecked = false;
      return;
    }
    this.Reconsole_Problems = this.Reconsole_Problems.filter(i => i.problemTypeCode != element.problemTypeCode);

    if (event.target.checked == true) {
      element.isChecked = true;
      this.ReconsoladatedPatientInfo.problemList.filter(x => x == element).map(y => y.isChecked = true);
      this.Reconsole_Problems.push(element);
    }
    else {
      this.ReconsoladatedPatientInfo.problemList.filter(x => x == element).map(y => y.isChecked = false);
      element.isChecked = false;
    }

  }

  fnIsAllergiesChecked() {
    if (this.Reconsole_Allergy.length == 0)
      return false;
    return (this.Reconsole_Allergy.length == this.ReconsoladatedPatientInfo.allErgies.length)

  }
  fnAllergiesCheckboxClick(isChecked: boolean) {
    if (isChecked == true) {
      this.ReconsoladatedPatientInfo.allErgies.filter(i => i.disabled == false).forEach(element => {
        element.isChecked = true;
        this.Reconsole_Allergy.push(element);
      })
    }
    else {
      this.ReconsoladatedPatientInfo.allErgies.forEach(element => {
        element.isChecked = false;
      });
      this.Reconsole_Allergy = [];
    }


  }
  fnSelectedAllergy(element: any, checked: boolean) {
    this.Reconsole_Allergy = this.Reconsole_Allergy.filter(i => i.drugName != element.drugName);
    if (checked == true)
      this.Reconsole_Allergy.push(element);
  }

  fnIsMedicationsChecked() {
    if (this.Reconsole_Medications.length == 0)
      return false;
    return (this.Reconsole_Medications.length == this.ReconsoladatedPatientInfo.allErgies.length)

  }
  fnMedicationsCheckboxClick(isChecked: boolean) {
    this.Reconsole_Medications = [];
    if (isChecked == true) {
      this.ReconsoladatedPatientInfo.medicationList.filter(i => i.disabled == false).map(x => x.isChecked = true)
      this.Reconsole_Medications = this.ReconsoladatedPatientInfo.medicationList.filter(x => x.isChecked == true);
      this.importCdaXmlForm.patchValue({
        MedicationCheckbox: true
      })
    }
    else {
      this.ReconsoladatedPatientInfo.medicationList.filter(element => {
        element.isChecked = false;
      });
      this.importCdaXmlForm.patchValue({
        MedicationCheckbox: false
      })
    }


  }

  fnSelectedMedication(element: any, checked: boolean) {
    let medi_length = this.ReconsoladatedPatientInfo.medicationList.length;

    this.Reconsole_Medications = this.Reconsole_Medications.filter(i => i.medicationCode != element.medicationCode && i.routeCode != element.routeCode);
    if (checked == true) {
      this.ReconsoladatedPatientInfo.medicationList.filter(x => x == element).map(y => y.isChecked = true)
      this.Reconsole_Medications.push(element);
      let Recon_length = this.Reconsole_Medications.length;
      if (Recon_length == medi_length) {
        this.importCdaXmlForm.patchValue({
          MedicationCheckbox: true
        })
      } else {
        this.importCdaXmlForm.patchValue({
          MedicationCheckbox: false
        })
      }
    } else {
      this.ReconsoladatedPatientInfo.medicationList.filter(x => x == element).map(y => y.isChecked = false)
      let Recon_length = this.Reconsole_Medications.length;
      if (Recon_length == medi_length) {
        this.importCdaXmlForm.patchValue({
          MedicationCheckbox: true
        })
      } else {
        this.importCdaXmlForm.patchValue({
          MedicationCheckbox: false
        })
      }
    }

  }
  fnReviewandFinalize() {
    if (this.PatientId == '' || this.PatientId == null) {
      this.toastr.warning("Please Linked Patient Id");
      return;
    }
    const dialogref = this.dialog.open(ReviewandFinalizeComponent, {
      data: {
        Problems: this.Reconsole_Problems,
        Medications: this.Reconsole_Medications,
        Allergy: this.Reconsole_Allergy
      }
    });
    dialogref.afterClosed().subscribe(result => {
      if (result) {
        this.Reconsole_Problems = result.Reconsole_Problems;
        this.Reconsole_Allergy = result.Reconsole_Allergy;
        this.Reconsole_Medications = result.Reconsole_Medications;
        this.fnSaveMessage();
      }

    });
  }
  fnSaveMessage() {

    if (this.Reconsole_Problems.length == 0 && this.Reconsole_Allergy.length == 0 && this.Reconsole_Medications.length == 0)
      return;
    // const serializer = new XMLSerializer();
    // const problemsXMLStr = serializer.serializeToString(this.Reconsole_Problems[0]);
    const ProblemsList: any = [];
    this.Reconsole_Problems.forEach(x => {
      const data = {
        Name: x.problemTypeDisplayName,
        Code: x.problemTypeCode,
        startdate: x.problemStartTime,
        enddate: null,
        status: x.problemStatusCode,
        CodeType: "ICD",//x.codeType,
        msgId: this.directMessageId ? this.directMessageId : 0,
        snomedCode: x.snomedProblemCode,
        snomedname: x.snomedProblemDisplayName,
        author: x.authorName,
        InputModified: x.authorTime,
        Source: (this.ReconsoladatedPatientInfo.authorInformation.firstName ? this.ReconsoladatedPatientInfo.authorInformation.firstName : '') + ' ' +
          (this.ReconsoladatedPatientInfo.authorInformation.lastName ? this.ReconsoladatedPatientInfo.authorInformation.lastName : '') + '/' +
          this.ReconsoladatedPatientInfo.custodianInformation.custodianName


      }
      ProblemsList.push(data);
    })

    const MedicationList: any = [];
    this.Reconsole_Medications.forEach(x => {
      const data = {
        Name: x.medicationDisplayName
        , Code: x.medicationCode
        , codeType: 'RXNorm'
        , status: x.active
        , stopdate: null
        , Startdate: x.effectiveStartTime
        , Dose: x.dose
        , periodUnit: x.periodUnit
        , periodValue: x.periodValue
        , RouteCode: x.routeCode
        , InputModified: x.authorTime
        , RouteName: x.routeDisplayName,
        msgId: this.directMessageId ? this.directMessageId : 0,
        author: x.authorName,
        Source: (this.ReconsoladatedPatientInfo.authorInformation.firstName ? this.ReconsoladatedPatientInfo.authorInformation.firstName : '') + ' ' +
          (this.ReconsoladatedPatientInfo.authorInformation.lastName ? this.ReconsoladatedPatientInfo.authorInformation.lastName : '') + '/' +
          this.ReconsoladatedPatientInfo.custodianInformation.custodianName
      }
      MedicationList.push(data);
    })

    const AllergyList: any = [];
    this.Reconsole_Allergy.forEach(x => {
      const data = {
        Name: x.drugName
        , Code: x.drugId
        , codeType: x.drugCodeSystemName
        , Reaction: x.reactions
        , Severity: x.severity
        , InputModified: x.authorTime
        , Startdate: x.startDate,
        msgId: this.directMessageId ? this.directMessageId : 0,
        author: x.authorName,
        Source: (this.ReconsoladatedPatientInfo.authorInformation.firstName ? this.ReconsoladatedPatientInfo.authorInformation.firstName : '') + ' ' +
          (this.ReconsoladatedPatientInfo.authorInformation.lastName ? this.ReconsoladatedPatientInfo.authorInformation.lastName : '') + '/' +
          this.ReconsoladatedPatientInfo.custodianInformation.custodianName
      }
      AllergyList.push(data);
    });

    const posteddata = {
      PatientId: this.PatientId,
      UserID: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      LocationId: sessionStorage.getItem("LocationId"),
      cCDA_Reconsilation_Medications: MedicationList,// this.Reconsole_Medications,
      cCDA_Reconsilation_Problems: ProblemsList,// this.Reconsole_Problems,
      cCDA_Reconsilation_Allergies: AllergyList,//this.Reconsole_Allergy
    }
    this.fnSaveXMLToPatientDocuments()
    this._ccdaService.AddCDAReconsilationData(posteddata).subscribe(result => {
      this.Reconsole_Problems = [];
      this.Reconsole_Allergy = [];
      this.Reconsole_Medications = [];
      this.toastr.success("Successfully Added");
      //this.onCloseClick();
      this.fnPatientActiveData_Reconsolation();
    })


  }
  fnSaveXMLToPatientDocuments() {
    try {
      if (this.ImportCCDAID == 0)
        return;
      const dmDocObj: Idocument_DIrectmsg = {
        locationId: Number(sessionStorage.getItem("LocationId")),
        facilityId: Number(sessionStorage.getItem("FacilityId")),
        docCategoryId: this.ImportCCDAID.docCategoryId,
        subCategoryId: this.ImportCCDAID.subCategoryId,
        Notes: 'Import CCDA Document ',
        //docFileURL: this.docUrl,
        //base64string: this.dmObj.attachedObj.documentdata,
        //DocumentType: 'Direct Messaging Documents',
        //Docpath: '',
        documentId: '0',
        documentName: "IMPORT CCDA",
        documentdate: this._datePipe.transform(new Date(), "MM/dd/yyyy"),
        patientId: Number(sessionStorage.getItem("patientId")),
        subCategoryName: '',
        documentCategory: '',
        patFullName: '',
        patDOB: undefined,
        patGender: '',
        patAge: 0,
        extension: 'xml',
        encounterId: '',
        createdBy: sessionStorage.getItem('userId').toString(),
        fluoroscopeId: 0,
        count: 0,
        reportDocumentId: 0,

      }
      var base64string = this.XMLFileString;
      this.docService.UploadCDAMsgDocument(dmDocObj, base64string).subscribe(result => {
        //this.toastr.success("Document Saved Successfully")
      },
        (error) => { });
    }
    catch (e) { }

    //this.XMLFileString
  }
  fnLinkToPatient() {
    const dialogRef = this.dialog.open(SearchPatientDMPopupComponent,
      {
        data: { patient: this.ReconsoladatedPatientInfo }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.bannerService.toggle(result.patientId);
        // sessionStorage.setItem("patientId", result.patientId.toString());
        // sessionStorage.setItem("patientName", result.name);
        // CommonComponents.patientId = result.patientId;
        // CommonComponents.patientName = result.name;


        this.PatientPersonalInfo = result;
        this.PatientId = result.patientId;
        sessionStorage.setItem("XMLFileString", this.XMLFileString);
        sessionStorage.setItem("DirectMsgId", this.directMessageId);
        this.ngOnInit();
        // this.fnPatientActiveData_Reconsolation();
      }

      // else
      //   this.fnLinkToPatient();
      //  if(result != undefined && result != null){
      //   this._PatientformService.getPersonalInfo(Number(this.PatientId)).subscribe(res => {
      //     this.PatientPersonalInfo = res;
      //   })

      // this.PatientPersonalInfo.lastName = result.lastName;
      // this.PatientPersonalInfo.firstName = result.firstName;
      // this.PatientPersonalInfo.middleName = result.middleName
      // this.PatientPersonalInfo.dob = result.dob;
      // this.PatientPersonalInfo.genderName = result.gender
      // this.PatientId = result.patientId;
      // }
    });
  }
  fnDateFormat(datestr) {
    if (datestr && datestr.length >= 8 && datestr.indexOf('-') != -1) {
      return (datestr.split('-')[1] + '/' + datestr.split('-')[0] + '/' + datestr.split('-')[2]).slice(0, 10)
    }
    return datestr;

  }
  fnCDAHumanReadableFormat() {
    var wnd = window.open("about:blank", "", "_blank");
    wnd.document.write(this.CDAHumanReadableFormat);
  }
  PreviousNavigation() {
    if (this.directMessageId != '') {
      sessionStorage.removeItem("DirectMsgId");
      //this.router.navigateByUrl("/tasksandmessages");
      this.router.navigateByUrl('/', { skipLocationChange: true, queryParamsHandling: 'preserve' }).then(() =>
        this.router.navigateByUrl('/tasksandmessages?fromDirect=true'));
    } else {
      this.router.navigateByUrl("/ClinicalSummary");
    }
  }
}
